import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MyAccountComponent } from './my-account.component';
import { AccountLedgerComponent } from './account-ledger/account-ledger.component';
import { CompanyInformationComponent } from './company-information/company-information.component';
import { DelieveryAddressComponent } from './delievery-address/delievery-address.component';
import { EnduserAddressComponent } from './enduser-address/enduser-address.component';
import { UsersComponent } from './users/users.component';
import { PaymentSetupComponent } from './payment-setup/payment-setup.component';
import { ApitokensComponent } from './apitokens/apitokens.component';
import { ManageUserComponent } from './users/manage-user/edit-user/manage-user.component';
import { AddUserComponent } from './users/add-user/add-user.component';
import { PortalBrandingComponent } from './portal-branding/portal-branding.component';
import { EditEndUserAddressBookComponent } from './enduser-address/edit-end-user-address-book/edit-end-user-address-book.component';
import { MakePaymentComponent } from './make-payment/make-payment.component';
import { ReturnsComponent } from '../admin/returns/returns.component';
import { EditDeliveryAddressComponent } from './delievery-address/edit-delivery-address/edit-delivery-address.component';
import { AddDeliveryAddressComponent } from './delievery-address/add-delivery-address/add-delivery-address.component';
import { OpenOrdersComponent } from '../my-orders/open-orders/open-orders.component';
import { ShippedOrdersComponent } from '../my-orders/shipped-orders/shipped-orders.component';
import { OrderItemDetailComponent } from '../my-orders/order-item-detail/order-item-detail.component';
import { ProductDetailComponent } from '../product/productdetail/product.detail.component';
import { BackOrdersComponent } from '../my-orders/back-orders/back-orders.component';
import { ReturnSearchComponent } from '../admin/returns/return-search/return-search.component';
import {ReturnsDetailsComponent} from '../admin/returns/return-search/return-details/return-details.component';
import { ApicredentialsV2Component } from './apicredentialsV2/apicredentialsV2.component';
import { DevOpsAuthGuard } from '../admin/admin.authguard';


const routes: Routes = [
  {
    path: 'myAccount',
    component: MyAccountComponent,
    data: {
      breadcrumb: 'Account',
    },
    children: [
      {
        path: 'accountledger',
        component: AccountLedgerComponent,
        data: {
          breadcrumb: 'Account Ledger',
        },
      },
      {
        path: 'compinfo',
        component: CompanyInformationComponent,
        data: {
          breadcrumb: 'Company Information',
        },
      },
      {
        path: 'deliverylocations',
        component: DelieveryAddressComponent,
        data: {
          breadcrumb: 'Delivery Locations',
        },
        children: [
          {
            path: 'adddeliverylocation',
            component: AddDeliveryAddressComponent,
            data: {
              breadcrumb: 'Add Delivery Location',
            }
          },
          {
            path: 'editdeliverylocation',
            component: EditDeliveryAddressComponent,
            data: {
              breadcrumb: 'Edit Delivery Location',
            }
          },
        ]
      },
      {
        path: 'enduseraddress',
        component: EnduserAddressComponent,
        data: {
          breadcrumb: 'End User Address',
        },
        children: [
          {
            path: 'addenduser',
            component: EditEndUserAddressBookComponent,
            data: {
              breadcrumb: 'Add End User',
            }
          },
          {
            path: 'editenduseraddress',
            component: EditEndUserAddressBookComponent,
            data: {
              breadcrumb: 'Edit End User Address',
            }
          },
        ]
      },
      {
        path: 'users',
        component: UsersComponent,
        data: {
          breadcrumb: 'Manage Existing Users',
        },
        children: [
          {
            path: 'addusers',
            component: AddUserComponent,
            data: {
              breadcrumb: 'New User Details',
            }
          },
          {
            path: 'manage-user',
            component: ManageUserComponent,
            data: {
              breadcrumb: 'Edit User',
            }
          },
        ]
      },
      // {
      //   path: 'addusers',
      //   component: AddUserComponent,
      //   data: {
      //     breadcrumb: 'Add New User',
      //   }
      // },

      {
        path: 'payment/:response/:reference',
        component: MakePaymentComponent,
        data: {
          breadcrumb: 'Make a Payment',
        },
      },

      {
        path: 'payment',
        component: MakePaymentComponent,
        data: {
          breadcrumb: 'Make a Payment',
        },
      },
      {
        path: 'digitalwallet',
        component: PaymentSetupComponent,
        data: {
          breadcrumb: 'Digital Wallet',
        },
      },
      {
        path: 'APITokens',
        component: ApitokensComponent,
        data: {
          breadcrumb: 'API Tokens',
        },
      },
      {
        path: 'APICredentialsV2',
        component: ApicredentialsV2Component,
        canActivate: [DevOpsAuthGuard],
        data: {
          breadcrumb: 'API Credentials V2',
        },
      },
      {
        path: 'branding',
        component: PortalBrandingComponent,
        data: {
          breadcrumb: 'Branding',
        },
      },
      {
        path: 'returns',
        component: ReturnSearchComponent,
        data: {
          breadcrumb: 'Returns',
        },
        children: [
          {
            path: ':orderNo',
            component: ReturnsDetailsComponent,
            data: {
              breadcrumb: 'orderNo',
            }
          },
          {
            path: ':orderNo/:orderSuffix',
            component: ReturnsDetailsComponent,
            data: {
              breadcrumb: 'orderNo',
            }
          }
        ]
      },
      // {
      //   path: 'returns',
      //   component: ReturnsComponent,
      //   data: {
      //     breadcrumb: 'Returns',
      //   },

      // },
      // {
      //   path: 'openOrders',
      //   component: OpenOrdersComponent,
      //   data: {
      //     breadcrumb: 'Open Orders',
      //   },

      // },
      {
        path: 'openorders',
        component: OpenOrdersComponent,
        data: {
          breadcrumb: 'Open Orders',
        },
        children: [
          {
            path: 'orderitemdetail/:sku',
            component: OrderItemDetailComponent,
            data: {
              breadcrumb: 'sku',
            },
            children: [
              {
                path: 'product/:sku',
                component: ProductDetailComponent,
                children: [
                  {
                    path: 'bundledproduct/:sku',
                    component: ProductDetailComponent,
                    data: {
                      breadcrumb: 'sku',
                    }
                  }]
              },
              {
                path: 'payment',
                component: MakePaymentComponent,
                data: {
                  breadcrumb: 'Make a Payment',
                },
              },
              {
                  path: 'digitalwallet',
                  component: PaymentSetupComponent,
                  data: {
                    breadcrumb: 'Digital Wallet',
                  },
              }
            ]
          },
          {
            path: 'payment',
            component: MakePaymentComponent,
            data: {
              breadcrumb: 'Make a Payment',
            },
          },
          {
            path: 'digitalwallet',
            component: PaymentSetupComponent,
            data: {
              breadcrumb: 'Digital Wallet',
            },
          },
        ]
      },
      {
        path: 'backorders',
        component: BackOrdersComponent,
        children: [
          {
            path: 'orderitemdetail/:sku',
            component: OrderItemDetailComponent
          }
        ]
      },
      // {
      //   path: 'shippedOrders',
      //   component: ShippedOrdersComponent,
      //   data: {
      //     breadcrumb: 'Recently Invoiced Orders',
      //   },

      // }
      {
        path: 'shippedorders',
        component: ShippedOrdersComponent,
        data: {
          breadcrumb: 'Recently Invoiced Orders',
        },
        children: [
          {
            path: 'orderitemdetail/:sku',
            component: OrderItemDetailComponent,
            data: {
              breadcrumb: 'sku',
            },
            children: [
              {
                path: 'product/:sku',
                component: ProductDetailComponent,
                children: [
                  {
                    path: 'bundledproduct/:sku',
                    component: ProductDetailComponent,
                    data: {
                      breadcrumb: 'sku',
                    }
                  }]
              },
            ]
          }
        ]
      },



    ]
  },
  {
    path: 'account',
    redirectTo: '/myAccount',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MyAccountRoutingModule { }
